'use strict';

const serverVars = require('server-vars');

const DESKTOP = 'desktop';
const TABLET = 'tablet';
const MOBILE = 'mobile';

/**
 * Checks device type.
 * Device types are defined in global/costants/deviceTypes.es.js
 *
 * @return {boolean}
 */
const deviceType = {
    isMobile() {
        return serverVars.get('settings.deviceType') === MOBILE;
    },

    isTablet() {
        return serverVars.get('settings.deviceType') === TABLET;
    },

    isDesktop() {
        return serverVars.get('settings.deviceType') === DESKTOP;
    },

    isMobileOrTablet() {
        return this.isMobile() || this.isTablet();
    },
};

exports.deviceType = deviceType;
exports.DESKTOP = DESKTOP;
exports.TABLET = TABLET;
exports.MOBILE = MOBILE;
